<script setup lang="ts">
import { onMounted, onUpdated, ref, watch } from "vue";
import InputGroup from "./InputGroup.vue";
const root = ref<HTMLElement>();
const props = defineProps({
  label: {
    type: String,
    required: false,
    default: "",
  },
  labelFor: {
    type: String,
    required: false,
    default: "",
  },
  prependText: {
    type: String,
    required: false,
    default: "",
  },
  appendText: {
    type: String,
    required: false,
    default: "",
  },
  description: {
    type: String,
    required: false,
    default: "",
  },
  invalidFeedback: {
    type: String,
    required: false,
    default: "",
  },
});

const onInvalidFeedbackChange = () => {
  if (root.value) {
    if (props.invalidFeedback) {
      const input = root.value.querySelector("input,select,textarea");
      if (input) {
        input.classList.add("is-invalid");
      }
    } else {
      const input = root.value.querySelector("input,select,textarea");
      if (input) {
        input.classList.remove("is-invalid");
      }
    }
  }
};
onMounted(onInvalidFeedbackChange);
onUpdated(onInvalidFeedbackChange);
</script>

<template>
  <div ref="root" class="form-group mb-3">
    <label v-if="label" :for="labelFor" class="form-label">{{ label }}</label>
    <InputGroup
      :class="{ 'has-validation': !!invalidFeedback }"
      :prepend-text="prependText"
      :append-text="appendText"
    >
      <slot />
      <template v-if="$slots['prepend-slot']" v-slot:prepend-slot>
        <slot name="prepend-slot" />
      </template>
      <template v-if="$slots['append-slot']" v-slot:append-slot>
        <slot name="append-slot" />
      </template>
      <div v-if="invalidFeedback" class="invalid-feedback">
        {{ invalidFeedback }}
      </div>
    </InputGroup>
    <small v-if="description" class="form-text text-muted">{{
      description
    }}</small>
  </div>
</template>
